export interface IApiResponse<T> {
  isSuccess: boolean;
  hasErrors: boolean;
  timeStamp: Date;
  errors: string[];
  responses: string[];
  result: T;
}

export class LoaderState {
  displayLoader: boolean;
  isLoading: boolean;
  loaderId: number;
}

export interface ITotalRecords {
  totalRecords?: number;
}

export interface ICommonDto extends ITotalRecords {
  id: number;
  name: string;
  order?: number;
}
